import type { FieldPolicy } from "@apollo/client"

export const userCacheFields: Record<string, FieldPolicy> = {
  getUserById: {
    merge: false,
    read(_, { args, toReference, canRead }) {
      if (!args?.id) return
      const ref = toReference({ __typename: "User", Id: args.id })
      if (ref && canRead(ref)) return ref
    },
  },
}
